<template>
  <app-collapse-item v-bind:title="title" class="border rounded my-1">
    <template #header>
      <div class="lead collapse-title">
        {{ title }}
      </div>
      <b-dropdown variant="link" no-caret :right="$store.state.appConfig.isRTL" v-if="canAddTransaction">
        <template #button-content>
          <feather-icon
            icon="MoreVerticalIcon"
            size="16"
            class="align-middle text-body"
          />
        </template>

        <b-dropdown-item @click="$emit('editClicked')">
          <feather-icon icon="EditIcon" />
          <span class="align-middle ml-50">تعديل</span>
        </b-dropdown-item>

        <b-dropdown-item @click="$emit('deleteClicked')">
          <feather-icon icon="Trash2Icon" />
          <span class="align-middle ml-50">حذف</span>
        </b-dropdown-item>
      </b-dropdown>
    </template>
    <slot />
  </app-collapse-item>
</template>

<script>
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import { BButton, BDropdown, BDropdownItem } from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    AppCollapseItem,
    BButton,
    BDropdown,
    BDropdownItem,
  },
  props: {
    title: String,
  },
  computed: {
    ...mapGetters("NgoProfile", [ "canAddTransaction"]),
  },
};
</script>

<style lang="scss">
.btn.dropdown-toggle {
  padding: 0px;
}
</style>
